export const MOBILE_BP = 1024;
export const LAPTOP_BP = 1300;
export const SIMPLE_CAROUSEL_DELAY = 3000;
export const STARTED_SECOND_SCREEN = 700;
export const STARTED_MOB_SECOND_SCREEN = 100;
export const CV_LINK =
	'https://drive.google.com/file/d/1ODdAolg9G7VTTsFkbCv3BQzDuRyggcJb/view?usp=sharing';
